import { FC } from 'react';

type SearchCategoriesPropsType = {
  text: string;
  bgImg: string | undefined;
};

const SearchCategories: FC<SearchCategoriesPropsType> = ({ text, bgImg, onClick }) => {
  return (
    <div className="search-page-category-item relative" onClick={onClick}>
      <img src={bgImg} alt={text} className="absolute w-full h-full right-0 object-cover" />
      {/*<div className="text-white text-lg font-bold self-center z-10">{text}</div>*/}
    </div>
  );
};

export default SearchCategories;
